import { render, staticRenderFns } from "./appletdialog.vue?vue&type=template&id=68b2be50&scoped=true"
import script from "./appletdialog.vue?vue&type=script&lang=js"
export * from "./appletdialog.vue?vue&type=script&lang=js"
import style0 from "./appletdialog.vue?vue&type=style&index=0&id=68b2be50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b2be50",
  null
  
)

export default component.exports